<div *ngIf="errors" class="alert alert-danger alert-dismissible fade show">
  Invalid form: make sure to select the checkboxes a. b. and c. and fill the confirmed by section.
  <button (click)="errors = false" aria-label="Close" class="close" type="button">
    <span aria-hidden="true" class="pull-right">&times;</span>
  </button>
</div>
<div *ngIf="declarationError" class="alert alert-danger alert-dismissible fade show">
  Invalid terminal count: each colo must have at least one user (terminal) behind it according to the ICE policy.
  <button (click)="declarationError = false" aria-label="Close" class="close" type="button">
    <span aria-hidden="true" class="pull-right">&times;</span>
  </button>
</div>
<div *ngIf="serverError" class="alert alert-danger alert-dismissible fade show">
  An error has occurred while submitting your declaration.
  <button (click)="serverError = false" aria-label="Close" class="close" type="button">
    <span aria-hidden="true" class="pull-right">&times;</span>
  </button>
</div>
<div *ngIf="expiredError" class="alert alert-danger alert-dismissible fade show">
  This dad form is no longer editable.
  <button (click)="expiredError = false" aria-label="Close" class="close" type="button">
    <span aria-hidden="true" class="pull-right">&times;</span>
  </button>
</div>
<div *ngIf="successDeclaration" class="alert alert-success alert-dismissible fade show">
  The declaration has been successfully submitted.
  <button (click)="successDeclaration = false" aria-label="Close" class="close" type="button">
    <span aria-hidden="true" class="pull-right">&times;</span>
  </button>
</div>
<div *ngIf="!loading" class="container">
  <div>
    <h4 style="margin-bottom: 0; line-height: 100%; text-align: center ">
      <b>
        <u>Schedule 2</u>
        <br/>
        <u>Monthly Data Access Declaration (TheICE)</u>
      </b>
    </h4>
    <br>
    <p>
      <b>Vendor Providing the Datafeed:</b> {{ currentDad.vendor }}
    </p>
    <div>
      <b>Subscriber Name: </b>
      <span>{{ currentDad.billingAccount?.name }}</span>
    </div>
    <br>
    <div>
      <b>This Declaration Form covers data in relation to the following Exchanges for the month(s) listed</b>
    </div>
    <br/>
    <div *ngIf="!currentDad.isDadFormNewStyle" [formGroup]="dadDeclarationForm">
      <table class="declaration-table">
        <thead>
        <tr>
          <th rowspan="2">
            Declared Counts for Terminal <sup>1</sup>,<br> Handheld device <sup>2</sup> and Wallboard <sup>3</sup>
          </th>
          <th colspan="3" *ngFor="let market of currentDad.markets">
            {{ getMarketName(market) }}
          </th>
        </tr>
        <tr>
          <ng-container *ngFor="let market of currentDad.markets">
            <th *ngFor="let dadField of dadFields">
              <ng-container *ngIf="dadField.includes('terminal')">
                T <sup>1</sup>
              </ng-container>
              <ng-container *ngIf="dadField.includes('handheld')">
                H <sup>2</sup>
              </ng-container>
              <ng-container *ngIf="dadField.includes('wallboard')">
                W <sup>3</sup>
              </ng-container>
            </th>
          </ng-container>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let pop of currentDad.decodedPopList">
          <td>
            {{ pop.name }} {{ pop.street }}
          </td>
          <ng-container *ngFor="let market of currentDad.markets">
            <td *ngFor="let field of dadFields">
              {{ colsXArray[market + pop.name] }}
            </td>
          </ng-container>
        </tr>
        <tr *ngIf="previousMonthSubscriptionData?.declarations && seePreviousMonthDeclaration"
            class="tr-previous-month-declaration">
          <th>
            {{ previousUsageMonth | date: 'MMMM yyyy':'+8000' }}
            (Total for active colos)
          </th>
          <ng-container *ngFor="let market of currentDad.markets">
            <td *ngFor="let field of dadFields" style="width: 8%; border: 1px solid #ddd; padding: 8px;">
              <div *ngIf="field === 'handheld'" style="font-size: xx-small"> Total for ({{ countColsArray[market] }})
                colo
              </div>
              <div *ngIf="field !== 'handheld'" style="font-size: xx-small"><br></div>
              <input [disabled]="true" [value]="previousMonthDeclarationValue(market, field)" style="width: 100%"
                     type="text">
            </td>
          </ng-container>
        </tr>
        <tr *ngIf="seeOriginalClientDeclaration" class="tr-previous-month-declaration">
          <th>
            Original client count for
            {{ currentDad.usageMonth | date: 'MMMM yyyy':'+8000' }}
          </th>
          <ng-container *ngFor="let market of currentDad.markets">
            <td *ngFor="let field of dadFields" style="width: 8%; border: 1px solid #ddd; padding: 8px;">
              <div *ngIf="field === 'handheld'" style="font-size: xx-small"> Total for ({{ countColsArray[market] }})
                colo
              </div>
              <div *ngIf="field !== 'handheld'" style="font-size: xx-small"><br></div>
              <input [disabled]="true" [value]="originalClientDeclarationValue(market, field)" style="width: 100%"
                     type="text">
            </td>
          </ng-container>
        </tr>
        <tr *ngIf="!originalClientDeclarationMode">
          <th style="border: 1px solid #ddd; padding: 12px 8px;text-align: center;">
            {{ currentDad.usageMonth | date: 'MMMM yyyy':'+8000' }}
            (Total for active colos)
          </th>
          <ng-container *ngFor="let market of currentDad.markets">
            <td *ngFor="let field of dadFields" style="width: 8%; border: 1px solid #ddd; padding: 8px;">
              <div *ngIf="field === 'handheld'" style="font-size: xx-small"> Total for ({{ countColsArray[market] }})
                colo
              </div>
              <div *ngIf="field !== 'handheld'" style="font-size: xx-small"><br></div>
              <input [formControlName]="market + ' ' + field" min="0" style="width: 100%" type="number">
            </td>
          </ng-container>
        </tr>
        </tbody>
      </table>

      <div *ngIf="!originalClientDeclarationMode" class="row" style="margin-top: 10px; margin-left: 0;">
        <button (click)="toggleSeePreviousMonthDeclaration()"
                *ngIf="previousMonthSubscriptionData?.declarations"
                class="p-button-alert removable"
                label="{{previousMonthDeclarationBtnLabel}}"
                pButton></button>
        <button (click)="toggleSeeOriginalClientDeclaration()"
                *ngIf="currentDad.decodedOriginalClientDeclaration"
                class="p-button-info removable" style="margin-left: 5px;"
                label="{{originalClientDeclarationBtnLabel}}"
                pButton></button>
      </div>

    </div>

    <div *ngIf="currentDad.isDadFormNewStyle" [formGroup]="dadDeclarationForm">
      <table class="declaration-table">
        <thead>
        <tr>
          <th rowspan="2">
            Declared Counts for Terminal ,<br> Handheld device and Wallboard
          </th>
          <th rowspan="2" style="white-space: nowrap">
            VAN ID
          </th>
          <th rowspan="2" style="white-space: nowrap">
            Pop
          </th>
          <th *ngFor="let market of currentDad.markets" colspan="3">
            {{ getMarketName(market) }}
          </th>
        </tr>
        <tr>
          <ng-container *ngFor="let market of currentDad.markets">
            <th *ngFor="let dadField of dadFields">
              <ng-container *ngIf="dadField.includes('terminal')">
                T
              </ng-container>
              <ng-container *ngIf="dadField.includes('handheld')">
                H
              </ng-container>
              <ng-container *ngIf="dadField.includes('wallboard')">
                W
              </ng-container>
            </th>
          </ng-container>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let pop of currentDad.decodedPopList">
          <td>
            {{ pop.name }} {{ pop.street }}
          </td>
          <td>{{ pop.vanId.split('-')[0] }}</td>
          <td>{{ pop.vanId.split('-')[1] ?? '' }}</td>
          <ng-container *ngFor="let market of currentDad.markets">
            <td *ngFor="let field of dadFields">
              <ng-container *ngIf="colsXArray[market + pop.name] === 'X'">
                <input [formControlName]="market + ' ' + field + ' ' + pop.display_id" type="number">
              </ng-container>
            </td>
          </ng-container>
        </tr>
        <tr *ngIf="previousMonthSubscriptionData?.declarations && seePreviousMonthDeclaration"
            class="tr-previous-month-declaration">
          <th colspan="3">
            {{ previousUsageMonth | date: 'MMMM yyyy':'+8000' }}
            (Total for active colos)
          </th>
          <ng-container *ngFor="let market of currentDad.markets">
            <td *ngFor="let field of dadFields" style="width: 8%; border: 1px solid #ddd; padding: 8px;">
              <input [disabled]="true" [value]="previousMonthDeclarationValue(market, field)"
                     type="text">
            </td>
          </ng-container>
        </tr>
        <tr *ngIf="seeOriginalClientDeclaration" class="tr-previous-month-declaration">
          <th colspan="3">
            Original client count for
            {{ currentDad.usageMonth | date: 'MMMM yyyy':'+8000' }}
          </th>
          <ng-container *ngFor="let market of currentDad.markets">
            <td *ngFor="let field of dadFields" style="width: 8%; border: 1px solid #ddd; padding: 8px;">
              <div *ngIf="field === 'handheld'" style="font-size: xx-small"> Total for ({{ countColsArray[market] }})
                colo
              </div>
              <div *ngIf="field !== 'handheld'" style="font-size: xx-small"><br></div>
              <input [disabled]="true" [value]="originalClientDeclarationValue(market, field)" style="width: 100%"
                     type="text">
            </td>
          </ng-container>
        </tr>
        <tr *ngIf="!originalClientDeclarationMode">
          <th style="border: 1px solid #ddd; padding: 12px 8px;text-align: center;" colspan="3">
            {{ currentDad.usageMonth | date: 'MMMM yyyy':'+8000' }}
            (Total for active colos)
          </th>
          <ng-container *ngFor="let market of currentDad.markets">
            <td *ngFor="let field of dadFields" style="width: 8%; border: 1px solid #ddd; padding: 8px;">
              <div *ngIf="field === 'handheld'" style="font-size: xx-small"> Total for ({{ countColsArray[market] }})
                colo
              </div>
              <div *ngIf="field !== 'handheld'" style="font-size: xx-small"><br></div>
              <input [disabled]="true" [value]="getTotalValueForMarketAndField(market, field)" type="text">
            </td>
          </ng-container>
        </tr>
        </tbody>
      </table>
      <button
        (click)="toggleSeePreviousMonthDeclaration()"
        *ngIf="previousMonthSubscriptionData?.declarations"
        class="p-button-alert removable" style="margin-top: 10px; margin-left: 0;"
        label="{{previousMonthDeclarationBtnLabel}}"
        pButton></button>
      <button (click)="toggleSeeOriginalClientDeclaration()"
              *ngIf="currentDad.decodedOriginalClientDeclaration"
              class="p-button-info removable" style="margin-left: 5px;"
              label="{{originalClientDeclarationBtnLabel}}"
              pButton></button>
    </div>

    <br/>
    <div *ngIf="currentDad.isDadFormNewStyle">
      Terminals – The terminal fee is applicable to all devices, including but not limited to: Closed Feeds, Data feed Environments, Display Devices, Unique User ID’s, Algo-Boxes and Slave Devices, but not Handheld Devices or Wallboards.
    </div>

    <div *ngIf="!currentDad.isDadFormNewStyle">
      <strong><sup>1</sup></strong> The terminal fee is applicable to all devices, including but not limited to: Closed
      Feeds, Datafeed Environments,
      Display Devices, Unique User ID’s, Algo-Boxes and Slave Devices, but not Wallboards or Handheld Devices
      <a style="color: #0062cc" (click)="scrollToElement(defs)">(see Definitions below).</a><br>
      <strong><sup>2</sup></strong> Handheld Devices<br>
      <strong><sup>3</sup></strong> Wallboards<br>
    </div>
    <br>
    <div>
      This Declaration Form confirms that the Subscriber named above is using
      the Pricing Data for internal purposes only and that the Subscriber
      will seek permission from ICE Data prior to using any ICE Real Time,
      Delayed or End of Day Pricing Data outside of the Subscriber's
      internal network.
    </div>
    <br>
    <app-confirmation-section [currentDad]="currentDad" [formGroup]="dadDeclarationForm" [originalClientDeclarationMode]="originalClientDeclarationMode"
                              [previousMonthSubscriptionData]="previousMonthSubscriptionData">
    </app-confirmation-section>

    <div>
      <p style="margin-bottom: 0; line-height: 100%; page-break-before: always">
    <span>
      <span #defs><u>Definitions</u>:</span>
    </span>
      </p>
      <br/>
      <p style="margin-left: 0.07in; margin-bottom: 0; line-height: 100%">
    <span>
      <B>&quot;Closed Feed&quot; </B>
      means a Content transmission feed where the transmitter of the Content is
      able to control the permissioning of the Content on an end-user or
      application basis.
    </span>
      </p>
      <br/>
      <p style="margin-left: 0.07in; margin-bottom: 0; line-height: 100%">
    <span>
      <b>&quot;Datafeed Environment&quot; </b>
      means a system configuration whereby individual Display Devices access
      Content from a shared source or where the transmitter of Content is
      unable to control the permissioning of the Content on an end-user or
      application basis.
    </span>
      </p>
      <br/>
      <p style="margin-left: 0.07in; margin-bottom: 0; line-height: 100%">
    <span>
      <b>&quot;Display Device&quot;</b>
      means any authorized device wherein technical and administrative controls
      are administered by a Vendor which is not part of a Datafeed
      Environment configuration.
    </span>
      </p>
      <br/>
      <p style="margin-left: 0.07in; margin-bottom: 0; line-height: 100%">
    <span>
      <b>&quot;Handheld Device&quot; </b>
      means any form (i) of display or medium which projects, displays or makes
      visible an image which is less than 7 inches in diagonal length, or
      when combined with other forms of display or media, projects,
      displays or makes visible an image which is less than 7 inches in
      diagonal length or (ii) a small portable device such as a
      BlackBerry, cell phone, PDA or pager.  All other devices are
      considered Display Devices or Wallboards.
    </span>
      </p>
      <br/>
      <p style="margin-left: 0.07in; margin-bottom: 0; line-height: 100%">
    <span>
      <b>&quot;Slave Device&quot; </b>
      means a screen or Display Device attached to one or more other Display
      Devises and showing part or all of the image shown on the Display
      Device to which it is attached.
    </span>
      </p>
      <br/>
      <p style="margin-left: 0.07in; margin-bottom: 0; line-height: 100%">
    <span>
      <b>&quot;Wallboard&quot;</b>
      means any form of display or medium which projects, displays or makes visible
      an image which is greater than 42 inches in diagonal length or when
      combined with other forms of display or media projects, displays or
      makes visible an image which is greater than 42 inches in diagonal
      length.
    </span>
      </p>
    </div>
    <br>

    <div class="row removable" *ngIf="!originalClientDeclarationMode">
      <div class="col-6"></div>
      <div class="col-6">
        <button (click)="onSubmit()" class="p-button-success pull-right" icon="fa fa-floppy-o"
                label="Confirm and transmit your declaration"
                pButton type="submit"></button>
        <button class="p-button-danger pull-right" label="Cancel" pButton routerLink="/dad-admin"
                style="margin-right: 5px"></button>
      </div>
    </div>
  </div>
</div>
